import PhoneInputBase from '@components/FormInputs/PhoneField/PhoneField';
import TextField from '@components/v2/form/TextField/TextField';
import type { OutlinedInputProps } from '@mui/material';
import type { FocusEventHandler, InputHTMLAttributes } from 'react';
import type { CountryData } from 'react-phone-input-2';

interface PhoneFieldProps {
  value?: string;
  label?: string;
  name?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  onChange?: (value: string, data: CountryData) => void;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

const PhoneField = ({
  value,
  label,
  name,
  disabled,
  error,
  helperText,
  onChange,
  onBlur,
}: PhoneFieldProps) => (
  <TextField
    name={name}
    label={label}
    value={value}
    disabled={disabled}
    error={error}
    helperText={helperText}
    onBlur={onBlur}
    slotProps={{
      inputLabel: { shrink: true },
      input: {
        inputComponent: PhoneInputBase as unknown as OutlinedInputProps['inputComponent'],
        inputProps: {
          onChange: (phone: string, data: CountryData) => onChange?.(phone, data),
        } as unknown as InputHTMLAttributes<HTMLInputElement>,
      },
    }}
  />
);

export type { PhoneFieldProps };
export default PhoneField;
